import { useFormContext } from "react-hook-form";
import { ControlledInput, ControlledSelect } from "@dune/ui";
import {
	administrativeAuthorizationTypeToLabel,
	administrativeAuthorizationTypes,
} from "@dune/vars";
import { AdministrativeAuthorizationFormData } from "./useAdministrativeAuthorizationForm";

export const AdministrativeAuthorizationForm = ({
	disabled = false,
}: {
	disabled?: boolean;
}) => {
	const form = useFormContext<AdministrativeAuthorizationFormData>();
	const { control } = form;

	return (
		<div className="flex gap-4">
			<ControlledSelect
				name="administrativeAuthorizationType"
				control={control}
				required
				label="Type"
				options={administrativeAuthorizationTypes.map((type) => ({
					label: administrativeAuthorizationTypeToLabel[type],
					value: type,
				}))}
				disabled={disabled}
			/>
			<ControlledInput
				name="authorizationReference"
				control={control}
				label="Référence de l'autorisation"
				disabled={disabled}
			/>
		</div>
	);
};
